import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

export interface AppButtonProps extends ButtonProps {
  /** Show a centered spinner and disable the button. */
  loading?: boolean;
}

/**
 * The one button in the app. It's a thin wrapper over MUI `<Button>` that adds
 * a `loading` spinner; all styling lives in the theme's button variants
 * (`primary` | `signal` | `ghost` | `fire` | `muted`), so call sites only pick
 * a variant — no per-button colour/shape overrides.
 */
const AppButton = React.forwardRef<HTMLButtonElement, AppButtonProps>(
  ({ loading = false, disabled = false, children, ...rest }, ref) => (
    <Button ref={ref} disabled={disabled || loading} {...rest}>
      {children}
      {loading && (
        <CircularProgress
          size={18}
          thickness={5}
          sx={{ color: 'inherit', position: 'absolute' }}
        />
      )}
    </Button>
  ),
);
AppButton.displayName = 'AppButton';

export default AppButton;
